var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-search",
    {
      attrs: {
        inverted: "",
        color: "white-4",
        placeholder: "press Enter ↵ to search"
      },
      nativeOn: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onEnter($event)
        }
      },
      model: {
        value: _vm.searchQuery,
        callback: function($$v) {
          _vm.searchQuery = $$v
        },
        expression: "searchQuery"
      }
    },
    [
      _c("q-autocomplete", {
        ref: "autocompleteRef",
        attrs: { "min-characters": 2, "max-results": 20 },
        on: { search: _vm.runSearch, selected: _vm.itemSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }